/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./resources/app.ts":
/*!**************************!*\
  !*** ./resources/app.ts ***!
  \**************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _scripts_components_Consent_Consent__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./scripts/components/Consent/Consent */ "./resources/scripts/components/Consent/Consent.ts");
/* harmony import */ var _scripts_components_Collection_ReadMoreCollection__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./scripts/components/Collection/ReadMoreCollection */ "./resources/scripts/components/Collection/ReadMoreCollection.ts");
/* harmony import */ var _scripts_components_NotificationPopup_NotificationPopupSession__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./scripts/components/NotificationPopup/NotificationPopupSession */ "./resources/scripts/components/NotificationPopup/NotificationPopupSession.ts");



customElements.define("notification-popup-session", _scripts_components_NotificationPopup_NotificationPopupSession__WEBPACK_IMPORTED_MODULE_2__["default"]);
var consent = new _scripts_components_Consent_Consent__WEBPACK_IMPORTED_MODULE_0__["default"]();
consent.init();
(0,_scripts_components_Collection_ReadMoreCollection__WEBPACK_IMPORTED_MODULE_1__["default"])();

/***/ }),

/***/ "./resources/scripts/components/Collection/ReadMoreCollection.ts":
/*!***********************************************************************!*\
  !*** ./resources/scripts/components/Collection/ReadMoreCollection.ts ***!
  \***********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ initReadMoreCollection)
/* harmony export */ });
function initReadMoreCollection() {
  function toggleReadMoreLess() {
    var readmore = document.querySelectorAll(".readmore-open");
    var readless = document.querySelectorAll(".readmore-close");
    var readmoreContent = document.querySelectorAll(".readmore-content");
    if (readmore && readless && readmoreContent) {
      readmore.forEach(function (readmoreBtn, index) {
        readmoreBtn.addEventListener("click", function (event) {
          event.preventDefault();
          readmoreContent.forEach(function (content) {
            return content.classList.remove("readmore-content");
          });
          readmore.forEach(function (btn) {
            return btn.classList.add("tw:hidden");
          });
          readmore.forEach(function (btn) {
            return btn.classList.remove("md:tw:flex");
          });
          readless[index].classList.remove("tw:hidden");
          readless[index].classList.add("md:tw:flex");
        });
      });
      readless.forEach(function (readlessBtn, index) {
        readlessBtn.addEventListener("click", function (event) {
          event.preventDefault();
          readmoreContent.forEach(function (content) {
            return content.classList.add("readmore-content");
          });
          readless.forEach(function (btn) {
            return btn.classList.add("tw:hidden");
          });
          readless.forEach(function (btn) {
            return btn.classList.remove("md:tw:flex");
          });
          readmore[index].classList.remove("tw:hidden");
          readmore[index].classList.add("md:tw:flex");
        });
      });
    }
  }
  document.addEventListener("DOMContentLoaded", toggleReadMoreLess);
  window.addEventListener("resize", toggleReadMoreLess);
}

/***/ }),

/***/ "./resources/scripts/components/Consent/Consent.ts":
/*!*********************************************************!*\
  !*** ./resources/scripts/components/Consent/Consent.ts ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Consent)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// Consent Component
//
// This class manages user consent tracking and interaction with Shopify's consent-tracking API.
// It includes methods for initializing consent features, handling consent updates, and interacting
// with Shopify's privacy settings.
//
// Key Functionalities:
// - `init()`: Loads Shopify's consent-tracking API and initializes the consent component.
// - `initConsentComponent()`: Sets up event listeners for consent actions, such as recalling consent preferences.
// - `handleConsentUpdate(state: string)`: Updates consent settings based on the user's current preferences.
//   - Parameters:
//     - `state`: A string representing the consent state ("granted", "denied", etc.).
// - `checkConsentBannerInteraction()`: Verifies if the user has interacted with the consent banner.
// - `gtag(...args)`: Pushes consent-related events to the Google Tag Manager data layer.
// - `recallConsent()`: Displays the privacy banner to allow users to update their consent preferences.
// - `logConsent(consentSettings: object)`: Logs the user's consent preferences to a database or analytics tool.
//
// Dependencies:
// - `window.dataLayer`: Required for Google Consent Mode V2 integration.
// - Shopify Customer Privacy Banner: Must be enabled in the Shopify admin panel.
//
// Error Handling:
// - Errors in loading Shopify features (e.g., API initialization failures) are logged to the console without blocking the process.
//
// Extensibility:
// - Support additional consent categories or analytics tools by extending `handleConsentUpdate` and other methods.
// - Update `logConsent` to integrate with custom databases or third-party analytics platforms as needed.
//
// Notes:
// - Local storage is used to persist consent settings across sessions.
// Usage Example:
// 1. Import the `Consent` class and initialize it in your application:
// ---- import Consent from './scripts/components/Consent/Consent';
// ---- const consent = new Consent();
// ---- consent.init();
//
// 2. To enable the recall consent feature, add an element with the ID "recall-consent" to the DOM:
// ---- <a href="#" id="recall-consent"></a>
//
// 3. Add Locales: en: "change_cookie_settings": "Change your cookie settings", da: "change_cookie_settings": "Tilpas dine cookie-indstillinger",
var Consent = /*#__PURE__*/function () {
  // declare dataLayer
  function Consent() {
    _classCallCheck(this, Consent);
    this.init = this.init.bind(this);
    this.handleConsentUpdate = this.handleConsentUpdate.bind(this);
    this.checkConsentBannerInteraction = this.checkConsentBannerInteraction.bind(this);
    this.gtag = this.gtag.bind(this);
    this.recallConsent = this.recallConsent.bind(this);
  }
  return _createClass(Consent, [{
    key: "init",
    value: function () {
      var _init = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this = this;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              window.Shopify.loadFeatures([{
                name: "consent-tracking-api",
                version: "0.1"
              }], function (error) {
                if (error) {
                  // eslint-disable-next-line no-console
                  console.error("Error loading features: ", error);
                  return;
                }
                // eslint-disable-next-line no-console
                console.log("Consent tracking API loaded");
                _this.initConsentComponent();
              });
            case 1:
              return _context.a(2);
          }
        }, _callee);
      }));
      function init() {
        return _init.apply(this, arguments);
      }
      return init;
    }()
  }, {
    key: "initConsentComponent",
    value: function () {
      var _initConsentComponent = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _this2 = this;
        var recallConsentElement;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              window.dataLayer = window.dataLayer || [];
              document.addEventListener("visitorConsentCollected", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
                return _regenerator().w(function (_context2) {
                  while (1) switch (_context2.n) {
                    case 0:
                      _this2.handleConsentUpdate("update");
                    case 1:
                      return _context2.a(2);
                  }
                }, _callee2);
              })));
              recallConsentElement = document.getElementById("recall-consent");
              if (recallConsentElement) {
                recallConsentElement.addEventListener("click", function (event) {
                  event.preventDefault();
                  _this2.recallConsent();
                });
              }
            case 1:
              return _context3.a(2);
          }
        }, _callee3);
      }));
      function initConsentComponent() {
        return _initConsentComponent.apply(this, arguments);
      }
      return initConsentComponent;
    }()
  }, {
    key: "handleConsentUpdate",
    value: function () {
      var _handleConsentUpdate = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(state) {
        var visitorConsent, consent;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return window.Shopify.customerPrivacy.currentVisitorConsent();
            case 1:
              visitorConsent = _context4.v;
              consent = {
                functionality_storage: "granted",
                analytics_storage: visitorConsent.analytics === "yes" ? "granted" : "denied",
                personalization_storage: visitorConsent.analytics === "yes" ? "granted" : "denied",
                ad_storage: visitorConsent.marketing === "yes" ? "granted" : "denied",
                ad_user_data: visitorConsent.marketing === "yes" ? "granted" : "denied",
                ad_personalization: visitorConsent.marketing === "yes" ? "granted" : "denied",
                wait_for_update: 3000
              };
              this.gtag("consent", state, consent);
              // set local Storage for consent settings for further use on other pages or after page
              localStorage.setItem("consentSettings", JSON.stringify(consent));
            case 2:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function handleConsentUpdate(_x) {
        return _handleConsentUpdate.apply(this, arguments);
      }
      return handleConsentUpdate;
    }() /* eslint-disable */
  }, {
    key: "checkConsentBannerInteraction",
    value: (function () {
      var _checkConsentBannerInteraction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var visitorConsent;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return window.Shopify.customerPrivacy.currentVisitorConsent();
            case 1:
              visitorConsent = _context5.v;
              if (!(visitorConsent.preferences === "" && visitorConsent.analytics === "" && visitorConsent.marketing === "")) {
                _context5.n = 2;
                break;
              }
              return _context5.a(2, false);
            case 2:
              return _context5.a(2, true);
          }
        }, _callee5);
      }));
      function checkConsentBannerInteraction() {
        return _checkConsentBannerInteraction.apply(this, arguments);
      }
      return checkConsentBannerInteraction;
    }()
    /* eslint-disable */
    /* eslint-disable */
    )
  }, {
    key: "gtag",
    value: function gtag() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      window.dataLayer.push(arguments);
    }
    /* eslint-enable */
    /* eslint-disable */
  }, {
    key: "recallConsent",
    value: (function () {
      var _recallConsent = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              window.privacyBanner.showPreferences();
            case 1:
              return _context6.a(2);
          }
        }, _callee6);
      }));
      function recallConsent() {
        return _recallConsent.apply(this, arguments);
      }
      return recallConsent;
    }())
  }]);
}();


/***/ }),

/***/ "./resources/scripts/components/NotificationPopup/NotificationPopupSession.ts":
/*!************************************************************************************!*\
  !*** ./resources/scripts/components/NotificationPopup/NotificationPopupSession.ts ***!
  \************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ NotificationPopupSession)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var NotificationPopupSession = /*#__PURE__*/function (_HTMLElement) {
  function NotificationPopupSession() {
    var _this;
    _classCallCheck(this, NotificationPopupSession);
    _this = _callSuper(this, NotificationPopupSession);
    _defineProperty(_this, "popup", null);
    _defineProperty(_this, "storageKey", "");
    _defineProperty(_this, "observer", null);
    _this.markSeen = _this.markSeen.bind(_this);
    return _this;
  }
  _inherits(NotificationPopupSession, _HTMLElement);
  return _createClass(NotificationPopupSession, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      this.popup = this.querySelector("notification-popup");
      if (!this.popup) return;
      var sectionId = this.dataset.sectionId || this.popup.id || "default";
      this.storageKey = "notification-session-shown:".concat(sectionId);
      try {
        if (sessionStorage.getItem(this.storageKey) === "true") {
          this.remove();
          return;
        }
      } catch (e) {
        // ignore storage errors
      }
      this.observer = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i += 1) {
          var _this2$popup;
          var mutation = mutations[i];
          if (mutation.attributeName === "open" && (_this2$popup = _this2.popup) !== null && _this2$popup !== void 0 && _this2$popup.hasAttribute("open")) {
            var _this2$observer;
            _this2.markSeen();
            (_this2$observer = _this2.observer) === null || _this2$observer === void 0 || _this2$observer.disconnect();
            break;
          }
        }
      });
      this.observer.observe(this.popup, {
        attributes: true
      });
      var delayAttr = this.popup.getAttribute("apparition-delay") || "0";
      var delay = parseInt(delayAttr, 10);
      window.setTimeout(this.markSeen, (Number.isNaN(delay) ? 0 : delay) * 1000 + 500);
      this.popup.addEventListener("close", this.markSeen, {
        once: true
      });
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      var _this$observer;
      (_this$observer = this.observer) === null || _this$observer === void 0 || _this$observer.disconnect();
    }
  }, {
    key: "markSeen",
    value: function markSeen() {
      try {
        sessionStorage.setItem(this.storageKey, "true");
      } catch (e) {
        // ignore storage errors
      }
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./resources/styles/app.css":
/*!**********************************!*\
  !*** ./resources/styles/app.css ***!
  \**********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"/shopify-theme/assets/edition": 0,
/******/ 			"shopify-theme/assets/edition": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunksofieamaliejewellery_com"] = self["webpackChunksofieamaliejewellery_com"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	__webpack_require__.O(undefined, ["shopify-theme/assets/edition"], () => (__webpack_require__("./resources/app.ts")))
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["shopify-theme/assets/edition"], () => (__webpack_require__("./resources/styles/app.css")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;